import { render } from "./VegMainCourse.vue?vue&type=template&id=7ad78685"
import script from "./VegMainCourse.vue?vue&type=script&lang=js"
export * from "./VegMainCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__